import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { LIST_PANEL_WIDTH_CLASS } from './VirtualAppointmentMasterDetail';

// Placeholder shaped like the list/detail split while VAs load.
export function VirtualAppointmentSplitSkeleton() {
    return (
        <div className="flex-1 min-h-0 flex" aria-busy="true">
            <div
                className={`${LIST_PANEL_WIDTH_CLASS} border-r border-gray-200 p-3 flex flex-col gap-2`}
            >
                <div className="h-9 bg-gray-200 rounded-lg animate-pulse" />
                <div className="h-12 bg-gray-200 rounded-lg animate-pulse" />
            </div>
            <div className="flex-1 p-5">
                <div className="h-full bg-gray-200 rounded-lg animate-pulse" />
            </div>
        </div>
    );
}

// Placeholder shaped like a stack of VA cards while VAs load.
export function VirtualAppointmentStackSkeleton() {
    return (
        <div className="flex flex-col gap-3" aria-busy="true">
            <div className="h-40 bg-gray-200 rounded-xl animate-pulse" />
            <div className="h-12 bg-gray-200 rounded-xl animate-pulse" />
        </div>
    );
}

interface VirtualAppointmentLoadErrorProps {
    message: string;
    onRetry: () => void;
}

export function VirtualAppointmentLoadError({
    message,
    onRetry
}: VirtualAppointmentLoadErrorProps) {
    return (
        <div className="flex-1 min-h-0 flex items-center justify-center p-5">
            <div className="flex items-center gap-3 rounded-xl border border-red-300 bg-red-50 p-4">
                <ExclamationCircleIcon className="w-5 h-5 flex-shrink-0 text-red-800" />
                <p className="text-sm text-red-800">{message}</p>
                <button
                    type="button"
                    onClick={onRetry}
                    className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
                >
                    Retry
                </button>
            </div>
        </div>
    );
}
